import type { Messages } from '@/areas/customer/i18n/de';

/**
 * Customer-portal messages — English. Typed against the German reference.
 */
const en: Messages = {};

export default en;